export const checkIsValidRangePrice = (
  price: string,
  min: number,
  max: number
): boolean => {
  const priceInt = parseInt(price);

  return (
    !isNaN(priceInt) &&
    priceInt >= min &&
    priceInt <= max &&
    priceInt.toString().length === price.length
  );
};
